// extracted by mini-css-extract-plugin
export default {"card":"ModerableSourceCard_card__fmejW","card_multi":"ModerableSourceCard_card_multi__eHpQg"};